import { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';

import { useIsPWA } from './use-is-pwa';

const SESSION_KEY = 'pwa-launch-redirect-done';

export const usePwaLaunchRedirect = (): boolean => {
    const isPWA = useIsPWA();
    const { pathname } = useLocation();
    const isHomepage = pathname === '/';

    const [isLoading, setIsLoading] = useState(isHomepage);

    useEffect(() => {
        if (!isHomepage) {
            setIsLoading(false);
            return;
        }
        if (isPWA === null) return;

        if (!isPWA || sessionStorage.getItem(SESSION_KEY)) {
            setIsLoading(false);
            return;
        }

        sessionStorage.setItem(SESSION_KEY, '1');
        navigate('/app/', { replace: true });
    }, [isPWA, isHomepage]);

    return isLoading;
};
